// noinspection GraphQLUnresolvedReference

import { gql, GraphQLClient } from 'graphql-request'

import { articuloFragment } from '../../../base/fragments/articuloFragment.ts'
import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'
import { PageInfoProps, PageInputProps } from '../../../interfaces'
import { ArticuloProps } from '../../../interfaces/articulo.ts'

/**
 * Respuesta de productos
 */
interface ApiArticulosResponse {
  docs: ArticuloProps[]
  pageInfo: PageInfoProps
}

const query = gql`
  ${articuloFragment}
  query LISTADO($cds: Int!, $limit: Int!, $reverse: Boolean, $page: Int!, $query: String) {
    articuloListado(cds: $cds, limit: $limit, reverse: $reverse, page: $page, query: $query) {
      docs {
        ...ArticuloFields
      }
      pageInfo {
        hasNextPage
        hasPrevPage
        totalDocs
        limit
        page
        totalPages
      }
    }
  }
`

/**
 * Listado de articulos con paginacion
 * @param pageInfo
 */
export const apiArticuloListado = async (pageInfo: PageInputProps): Promise<ApiArticulosResponse> => {
  try {
    const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)
    // Set a single header
    client.setHeader('authorization', `Bearer ${token}`)

    const data: any = await client.request(query, { ...pageInfo, cds: 1 })
    return data.articuloListado
  } catch (e: any) {
    throw new MyGraphQlError(e)
  }
}
